import React from "react";
import myVideo from '../../videos/OHA4Years.mp4';

import img1 from "../../images/sadaqatnews1/img (7).jpg";
import img2 from "../../images/oha/img (12).jpg";
import img3 from "../../images/oha/img (1).jpg";
import img4 from "../../images/activities/soccor/img (2).jpg";


const LatestProject = () => {
  const projects = [
    {
      name: "Sedaqat Educational Center",
      manager: "Aisha Hakimi",
      location: "Dasht-e-Barchi, Kabul",
      students: "140 Students",
      description: "Provides eight hours of daily lessons in English, Math, Pashto, and basic principles including reading, writing, and arithmetic. The center employs four teachers, a manager, assistant manager, and a guard.",
      subjects: ["English", "Math", "Pashto", "Basic Principles"],
      budget: "$550-600/month",
      icon: "🏫",
      image: img1,
    },
    {
      name: "Action Not Word Educational Course",
      manager: "Walid Hoida",
      location: "Qasaba, Kabul",
      students: "Multiple Grades",
      description: "Comprehensive educational program offering diverse subjects to empower students with both academic knowledge and practical skills for their future.",
      subjects: ["Religious Studies", "Sewing", "Drawing", "English", "Math"],
      budget: "$300/month",
      icon: "📚",
      image: img2,
      imageAlt: "Students learning practical skills"
    },
    {
      name: "One Hour for Afghanistan (OHA)",
      manager: "Homayoun Ebrahim Khail",
      location: "Khwaja Bughra, Kabul",
      students: "Boys and Girls",
      description: "Founded by the family of Mohammad Waris 'Azimi' and active for over seven years, serving both boys and girls. Recently established a sewing class for women to help them become self-sufficient.",
      subjects: ["Academic Programs", "Women's Sewing Class", "Self-Sufficiency Training"],
      budget: "$200/month",
      icon: "🎓",
      image: img3,
      imageAlt: "Women learning sewing skills"
    },
    {
      name: "Indoor Soccer Team",
      manager: "Atiq Raheen",
      location: "Afghanistan",
      students: "Grades 4-6",
      description: "Sports program for children providing physical education, teamwork skills, and competitive opportunities. Students actively participate in training sessions and tournaments.",
      subjects: ["Soccer Training", "Team Building", "Tournament Participation"],
      budget: "$200/month",
      icon: "⚽",
      image: img4,
      imageAlt: "Children playing indoor soccer"
    }
  ];

  return (
    <div className="latestProject" data-aos="fade-up">
      <h1 data-aos="fade-down" data-aos-delay="100">Our Active Projects</h1>
      
      {/* Project Cards Grid */}
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div 
            key={index} 
            className="project-card"
            data-aos="fade-up"
            data-aos-delay={200 + (index * 100)}
          >
            <div className="project-image">
              <img 
                src={project.image} 
                alt={project.imageAlt}
                loading="lazy"
              />
            </div>
            
            <div className="project-content">
              <div className="project-icon">{project.icon}</div>
              <h3>{project.name}</h3>
              <div className="project-meta">
                <span className="project-location">📍 {project.location}</span>
                <span className="project-students">👥 {project.students}</span>
              </div>
              <p className="project-description">{project.description}</p>
              <div className="project-subjects">
                {project.subjects.map((subject, idx) => (
                  <span key={idx} className="subject-tag">{subject}</span>
                ))}
              </div>
              <div className="project-footer">
                <span className="project-manager">Manager: {project.manager}</span>
                <span className="project-budget">{project.budget}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Video Section */}
      <div className="videos-section">
        <h2 data-aos="fade-up" data-aos-delay="100">Project Highlights</h2>
        
        {/* OHA 4 Years Anniversary */}
        <div className="video-container" data-aos="zoom-in" data-aos-delay="200">
          <h3>One Hour for Afghanistan - 4 Years Anniversary</h3>
          <video width="100%" height="100%" controls>
            <source src={myVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        
      </div>
    </div>
  );
};

export default LatestProject;